export const TEXT_ACTINGS: Record<string, [string, string]> = {
	control: ['icon24:gear', 'control'],
	create: ['icon24:plus', 'create'],
	update: ['icon24:input', 'update'],
	updateSelected: ['icon24:input', 'updateSelected'],
	delete: ['icon24:trash', 'delete'],
	deleteSelected: ['icon24:trash', 'deleteSelected'],
	deletes: ['icon24:trash', 'deletes'],
	reset: ['icon24:refresh', 'reset'],
	move: ['icon24:chain', 'move'],
	list: ['icon24:list', 'list'],
	detail: ['icon24:eye', 'detail'],
	yes: ['icon24:check', 'yes'],
	no: ['icon24:cancel', 'no'],
	save: ['icon24:check', 'save'],
	submit: ['icon24:check', 'submit'],
	cancel: ['icon24:cancel', 'cancel'],
	change: ['icon24:refresh', 'refresh'],
	changes: ['icon24:refresh', 'changes'],
	close: ['icon24:cancel', 'close'],
	download: ['icon24:file-download', 'download'],
	upload: ['icon24:file-upload', 'upload'],
	orderSelected: ['icon24:drag', 'orderSelected'],
	select: ['icon24:check', 'select'],
	result: ['icon24:check', 'result'],
	stop: ['icon24:stop', 'stop'],
	start: ['icon24:lightning', 'start'],
	permit: ['icon24:key', 'permit'],
	maxSize: ['icon24:fullscreen', 'maxSize'],
	defaultSize: ['icon24:fullscreen-leave', 'defaultSize'],
}